import { NotificationsActive, HeadsetMic, AccessTime, Search } from "@mui/icons-material"
import { Box, Tooltip } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { useCallback, useContext, useEffect, useState, useRef } from "react"
import { useLocation } from "react-router"
import { WebSocketContext } from "../../Providers/WebSocket/WebSocketContext"

import { CondominiosContext } from "../../Providers/CondominiosContext/CondominiosContext"
import NumeroCond from "./NumeroCond/NumeroCond"
import CardEvento from './CardEvento/CardEvento'
import moment from "moment/moment"
import { EventosContext } from "../../Providers/EventosContext/EventosContext"
import GridCameras from './GridCameras/GridCameras'
import { LogadoContext } from "../../Providers/LogadoContext/LogadoContext"
import { UserContext } from "../../Providers/UserContext/UserContex"
import ModalConfirmacaoEvento from './ModalConfirmacaoEvento/ModalConfirmacaoEvento'
import PaginacaoVertical from "../../Components/PaginacaoVertical/PaginacaoVertical"

import {
    Container, SessaoMonitoramento, RightSessionSx, SessaoCond,
    GridMonitoramento,
    GridNaoAtendidos,
    GridEmAtendimento,
    GridAguardando,
    BoxNaoAtendidos,
    TitleBoxMonitoramento,
    IconTitleBoxMonitoramento,
    BoxEmAtendimento,
    BoxEmEspera,
    GridNumeroCond,
    GridCamerasSx,
    GridNumeroVersao
} from "./SxMonitoramentoPage"
import { showNotify } from '../../Utils/Utils'
import { prioridades } from "../../Utils/optionsEventos"
import { LayoutSistImagem, MeuMonitorDigifort } from "./sistemaDeImagem"
import LupaPesquisarCond from "./LupaPesquisarCond/LupaPesquisarCond"
import useStatusEvento from '../../hook/useStatusEvento'
import { RightSession } from './RightSession/RightSession'
import { ChangeComponentContext } from "../../Providers/ChangeComponentContext/ChangeComponentContext"
import ModalConfirmaApagaVisitanteContext from "./ModalConfirmaApagaVisitanteContext/ModalConfirmaApagaVisitanteContext"

let dguard_center_conf = {
    porta: 80,
    usuario: 'admin',
    senha: 'seventh'
}
global.dguard_center_conf = dguard_center_conf

let digifort_conf = {
    porta: 80,
    usuario: 'admin',
    senha: 'seventh'
}
global.digifort_conf = digifort_conf

let ip_local = false
global.ip_local = ip_local
global.sendWs = () => {}

const MonitoramentoPage = () => {
    const { pathname } = useLocation()

    const [modalConfirmacaoEventoOpen, setModalConfirmacaoEventoOpen] = useState(false)
    const [modalConfirmaApagaVisitanteContext, setModalConfirmaApagaVisitanteContext] = useState(false)
    const [funcaoHandleClickEvento, setFuncaoHandleClickEvento] = useState(() => { })
    const [eventoDoubleClick, setEventoDoubleClick] = useState()

    const { mudarStatusEvento } = useStatusEvento()
    const { condominios, addActiveCond, rmActiveCond, activeCond } = useContext(CondominiosContext)
    const { eventosNA, setEventosNA, eventosEA, setEventosEA, eventosEE, setEventosEE, eventosEO, setEventosEO, setInfosEvento, eventoSelecionado, updateEventoSelecionado, removerEventoSelecionado } = useContext(EventosContext)
    const { sendWs, addRoute } = useContext(WebSocketContext)
    global.sendWs = sendWs
    const { changeShowComponent } = useContext(ChangeComponentContext)

    const { logado } = useContext(LogadoContext)
    const { user, check } = useContext(UserContext)

    const refCardsNA = useRef()
    const refCardsEE = useRef()
    const refCardsEO = useRef()

    let eventosNA_ord = []
    let eventosEA_ord = []
    let eventosEE_ord = []
    let eventosEO_ord = []

    useEffect(() => {
        if (logado) {
            getInfosPage()
            addRoute('agrup', agruparEvento)
        }
    }, [logado])
    addRoute('assumir_evento', assumir_evento)

    /**
     * Clona a lista de objetos dos eventos (sem referenciar a lista original)
     */
    const clonarLista = (lista) => {
        let ret = []
        for (const el of lista) {
            ret.push(Object.assign({}, el))
        }
        return ret
    }
    const ordenaListaByEvSelecionado = (lista) => {
        if (Array.isArray(lista)) {
            for (const i in lista) {
                lista[i].chave_ordenacao = regraOrdenacao(lista[i])

                lista = lista.sort((a, b) => {
                    if (a.chave_ordenacao < b.chave_ordenacao) return -1

                    if (a.chave_ordenacao > b.chave_ordenacao) return 1

                    return 0
                })
            }
        }
        // if (Array.isArray(lista)) {
        //     lista = lista.sort((ev) => {
        //         return (ev.id == eventoSelecionado.id ? -1 : 1)
        //     })
        // }
        return lista
    }

    function regraOrdenacao(ev) {
        let chave = null

        // se estiver na coluna em atendimento e for o evento selecionado
        chave = (ev.status == 2 && ev.id == eventoSelecionado.id ? '0' : '1')

        // Se não estiver na coluna não atendidos e o evento for seu
        chave += (ev.usuario_tratando && ev.usuario_tratando.id == user.id ? '0' : '1')

        // prioridade
        chave += `${(prioridades.length + 1) - ev.prioridade}`

        // tempo
        chave += `${ev.id}`

        return chave
    }

    // function regraOrdenacao(ev, ev2) {
    //     if (ev.id == eventoSelecionado.id) {
    //         return -1
    //     } else {
    //         if (ev.usuario_tratando && ev.usuario_tratando.id == user.id) {
    //             if (ev.prioridade )
    //         } else {
    //             return 1
    //         }
    //     }
    // }

    const ordenaListasEventos = () => {
        eventosNA_ord = ordenaListaByEvSelecionado(clonarLista(eventosNA))
        eventosEA_ord = ordenaListaByEvSelecionado(clonarLista(eventosEA))
        eventosEE_ord = ordenaListaByEvSelecionado(clonarLista(eventosEE))
        eventosEO_ord = ordenaListaByEvSelecionado(clonarLista(eventosEO))

        // if (eventoSelecionado && eventoSelecionado.id != '') {
        //     switch (eventoSelecionado.status) {
        //         case 1:
        //             eventosNA_ord = ordenaListaByEvSelecionado(eventosNA_ord)
        //             break
        //         case 2:
        //             eventosEA_ord = ordenaListaByEvSelecionado(eventosEA_ord)
        //             break
        //         case 3:
        //             // eventosEE_ord = ordenaListaByEvSelecionado(eventosEE_ord)
        //             break
        //         case 4:
        //             // eventosEO_ord = ordenaListaByEvSelecionado(eventosEO_ord)
        //             break
        //         default:
        //             break
        //     }
        // }
    }

    const trataIframe = (event) => {
        let origem = window.location.hostname
        if (event.origin.indexOf(origem) === -1) return

        if (event && event.data) {
            if (event.data.cmd === "obsligacao") {
                let status = event.data.dados.status ? "" : " - Falhou"

                let msgHist = `${event.data.dados.nome} ligou para ${event.data.dados.nomeMorador},  ${event.data.dados.NomeBloco}: ${event.data.dados.Bloco},  ${event.data.dados.NomeApto}: ${event.data.dados.Apto} número ${event.data.dados.fone}${status}.`
                let msg = `${moment().format('HH:mm:ss')} - ${msgHist}`
                return updateObsIframe(msg, msgHist)
            }
            if (event.data.cmd === "obsligacaointerfone") {
                let status = event.data.dados.status ? "" : " - Falhou"

                let msgHist = `${event.data.dados.nome} ligou para o interfone ${event.data.dados.fone} da entrada ${event.data.dados.entrada}${status}.`
                let msg = `${moment().format('HH:mm:ss')} - ${msgHist}`
                return updateObsIframe(msg, msgHist)
            }
            if (event.data.cmd === "obsEnviarMsgApp") {
                let status = event.data.dados.status ? "" : " - Falhou"
                let destinatario = event.data.dados.todos ? `todos os moradores do condomínio` : `o morador: ${event.data.dados.morador}`
                let msg = `${moment().format('HH:mm:ss')} - ${event.data.dados.nome} enviou msg para ${destinatario}.`
                let msgHist = `${event.data.dados.nome} enviou msg para ${destinatario}${status}.`
                return updateObsIframe(msg, msgHist)
            }
            if (event.data.cmd === "obsEncomenda") {
                let status = event.data.dados.status ? "" : " - Falhou"
                let msg = `${moment().format('HH:mm:ss')} - ${event.data.dados.nome} postou uma encomenda para o imóvel: (${event.data.dados.imovel})${status}.`
                let msgHist = `${event.data.dados.nome} postou uma encomenda para o imóvel: (${event.data.dados.imovel})${status}.`
                return updateObsIframe(msg, msgHist)
            }
            if (event.data.cmd === "obsGerarLink") {
                let status = event.data.dados.status ? "" : " - Falhou"
                let msg = `${moment().format('HH:mm:ss')} - ${event.data.dados.nome} gerou um link para o morador: ${event.data.dados.morador}${status}.`
                let msgHist = `${event.data.dados.nome} gerou um link para o morador: ${event.data.dados.morador}${status}.`
                return updateObsIframe(msg, msgHist)
            }
            if (event.data.cmd === "obsAbrirEntrada") {
                let status = event.data.dados.status ? "" : " - Falhou"
                const visitantes = event.data.dados.visitantes ? `, para o(s) visitante(s): ${event.data.dados.visitantes}` : ''
                const morador = event.data.dados.nomeMorador ? ` com a autorização do morador ${event.data.dados.nomeMorador}` : ''
                let msgHist = `${event.data.dados.nome} Abriu a ${event.data.dados.sentido == 'S' ? 'saída' : 'entrada'}: ${event.data.dados.entrada}${visitantes}${morador}${status}.`
                let msg = `${moment().format('HH:mm:ss')} - ${msgHist}`
                return updateObsIframe(msg, msgHist)
            }
        }
    }
    global.trataIframe = trataIframe

    useEffect(() => {
        if (logado && eventoSelecionado.id != '') {
            window.addEventListener("message", trataIframe, true)
            return () => window.removeEventListener('message', trataIframe, true)
        } else if (eventoSelecionado.id == '') {
            handleStopCams()
            rmActiveCond()
        }
        // if (logado && eventoSelecionado.id != '') {
        // window.addEventListener("keydown", (event) => { atalhosSone(event) }, true)
        // return () => window.removeEventListener('keydown', atalhosSone, true)
        // }
    }, [logado, eventoSelecionado])

    const Enviar_Mensagem_AbaWeb = (obj) => {
        // ex obj: { status: true, msg: "olá mundo do iframe" }
        let iframe = document.getElementById('iframe').contentWindow
        iframe.postMessage(obj, "*")
    }
    global.Enviar_Mensagem_AbaWeb = Enviar_Mensagem_AbaWeb

    const updateObsIframe = (msgObs, msgHist) => {
        if (eventoSelecionado.id && user.id == eventoSelecionado.usuario_tratando.id && eventoSelecionado.status == 2) {
            sendWs('gravarHistorico', { id: eventoSelecionado.id, historico: msgHist })
            if (activeCond?.gerar_logs_aut_obs) {
                let novaObs = eventoSelecionado.obs_fechamento ? eventoSelecionado.obs_fechamento + `\n${msgObs}` : msgObs
                updateEventoSelecionado({ obs_fechamento: novaObs })
                sendWs('gravarObservacao', { id: eventoSelecionado.id, observacao: novaObs })
                const obsInput = document.getElementById('input-obs')
                obsInput.focus()
            }
        }
    }

    const getInfosPage = () => {
        addRoute('buscarConfigsGeraisMO', configsGeraisMO)
        addRoute('buscarListagens', RetornoBuscarListagens)

        sendWs('buscarConfigsGeraisMO', {})
    }

    const configsGeraisMO = (msg) => {
        if (!msg.data || !msg.data.status) { return false }
        const { dguard, digifort, ip_local, ip_pbx, chatgpt_ativo, nome_revenda, obrigatorio_tag_oini, versoes, delay_req_dguard, mandados_ativo } = msg.data.dados

        global.dguard_center_conf = dguard
        global.digifort_conf = digifort
        global.ip_local = ((ip_local != '127.0.0.1' && ip_local != 'localhost') ? ip_local : window.location.hostname)
        global.ip_pbx = ip_pbx
        global.chatgpt_ativo = chatgpt_ativo
        global.nome_revenda = nome_revenda
        global.obrigatorio_tag_oini = obrigatorio_tag_oini
        global.versoes = versoes
        global.delay_req_dguard = delay_req_dguard
        global.mandados_ativo = mandados_ativo

        localStorage.setItem('nome_revenda', nome_revenda)

        if (digifort) {
            sendWs("buscarListagens", { listagens: { monitoresDigifort: [] } })
        }

        if (versoes.Plus && versoes.Plus != "") {
            document.getElementById('versao_sistema').innerHTML = `v. ${versoes.Plus}`
        }
    }

    const handleChangeCond = (id_central, click_menu_lateral = false) => {
        LayoutSistImagem(condominios, id_central, user)
        addActiveCond(id_central, click_menu_lateral)
        removerEventoSelecionado()
        changeShowComponent('abaWeb-tratarEvento')
    }

    const handleTrataEvento = useCallback((qnt, evento, index) => {
        LayoutSistImagem(condominios, evento.id_central, user)
        switch (qnt) {
            case 1: { // single click
                addActiveCond(evento.id_central, false, evento.id_one_log)
                setInfosEvento(evento.id)
                break
            }
            default: { // double or other clicks
                if (check && (check.estado_jornada !== 1 && check.estado_jornada !== 3)) {
                    showNotify("warning", "É necessário estar em jornada antes de realizar atendimentos!")
                    return
                }
                let status = 2
                if (evento.status == status) {
                    if (user.id != evento.usuario_tratando?.id) {
                        setModalConfirmacaoEventoOpen(true)
                        setEventoDoubleClick(evento)
                        setTimeout(() => {
                            const obsInput = document.getElementById('input-obs')
                            obsInput.focus()
                        }, 300)
                    } else {
                        mudarStatusEvento(evento.id, 3)
                        addActiveCond(evento.id_central)
                        setInfosEvento(evento.id)
                        setTimeout(() => {
                            const obsInput = document.getElementById('input-obs')
                            obsInput.focus()
                        }, 300)
                    }
                } else {
                    mudarStatusEvento(evento.id, 2)
                    addActiveCond(evento.id_central)
                    setInfosEvento(evento.id)
                    setTimeout(() => {
                        const obsInput = document.getElementById('input-obs')
                        obsInput.focus()
                    }, 300)
                }
                break
            }
        }
        setTimeout(() => {
            switch (evento.status) {
                case 1:
                    refCardsNA.current.scrollToItem(index, "center")
                    break
                case 3:
                    refCardsEE.current.scrollToItem(index, "center")
                    break
                case 4:
                    refCardsEO.current.scrollToItem(index, "center")
                    break
                default:
                    break
            }
            const eventosNobreak = ["EGFC", "EGRC", "EGFE", "EGRE"]
            if (eventosNobreak.includes(evento.evento)) {
                changeShowComponent("nobreak-tratarEvento")
            }
            const eventosCaixaAgua = ["OCDA", "OCD1", "OCD2", "OCD3"]
            if (eventosCaixaAgua.includes(evento.evento)) {
                changeShowComponent("caixaAgua-tratarEvento")
            }
            if (evento.evento == "ONRV") {
                changeShowComponent("ronda-tratarEvento")
            }
            if (evento.evento == "OCAP") {
                changeShowComponent("ocorrencias-tratarEvento")
            }
            if (evento.evento == "EVOS") {
                changeShowComponent('ordemServico')
            }
            if (evento.evento == "EVOS") {
                changeShowComponent('ordemServico')
            }
            if (evento.usuario_tratando.id == user.id && evento.mostrar_tela_visitante) {
                if ((evento.status == 2 && qnt == 1) || (qnt == 2 && (evento.status == 3 || evento.status == 4 || evento.status == 1))) {
                    changeShowComponent("visitantes-tratarEvento")
                }
            }
        }, 400)
    }, [addActiveCond, setInfosEvento])

    let clicks = 0
    let time = false

    function handleTimeout(evento, index) {
        if ((eventoSelecionado.evento == 'OVIS' || eventoSelecionado.evento == 'OINI') &&
        (evento.mostrar_tela_visitante) &&
    eventoSelecionado.id != '') {
            if (evento.id != eventoSelecionado.id) {
                setFuncaoHandleClickEvento({
                    funcao: () => {
                        handleTrataEvento(clicks, evento, index)
                        clicks = 0
                        time = false
                        setFuncaoHandleClickEvento(() => { })
                    }
                })
                setModalConfirmaApagaVisitanteContext(true)
            } else {
                time = false
                handleTrataEvento(clicks, evento, index)
                clicks = 0
            }
        } else {
            time = false
            handleTrataEvento(clicks, evento, index)
            clicks = 0
        }
    }

    const countClick = (ev, evento, index) => {
        clicks++
        if (!time) {
            time = true
            setTimeout(() => { handleTimeout(evento, index) }, 350)
        }
    }

    const EventosNA = () => {
        return (
            <PaginacaoVertical itemCount={eventosNA.length} itemSize={60} ref={refCardsNA}>
                {CardsNA}
                {/* CardsNAVariable */}
            </PaginacaoVertical>
        )
    }

    const EventosEA = () => {
        return (
            <PaginacaoVertical itemCount={eventosEA.length} itemSize={60}>
                {CardsEA}
            </PaginacaoVertical>
        )
    }

    const EventosEE = () => {
        return (
            <PaginacaoVertical itemCount={eventosEE.length} itemSize={60} ref={refCardsEE}>
                {CardsEE}
            </PaginacaoVertical>
        )
    }

    const EventosEO = () => {
        return (
            <PaginacaoVertical itemCount={eventosEO.length} itemSize={60} ref={refCardsEO}>
                {CardsEO}
            </PaginacaoVertical>
        )
    }

    // const CardsNAVariable = ({ data, index, style, setSize, windowWidth }) => {
    //     const rowRef = useRef({})

    //     useEffect(() => {
    //         let teste = rowRef.current.getBoundingClientRect().height
    //         setSize(index, rowRef.current.getBoundingClientRect().height)
    //     }, [setSize, index, windowWidth])

    //     const ev = data[index]
    //     return (
    //         <div key={index} ref={rowRef} style={{ ...style, paddingBottom: '1px' }}>
    //             <CardEvento type={1} ev={ev} onClick={countClick} id_ev_selecionado={eventoSelecionado.id == ev.id} />
    //         </div>
    //     )
    // }

    const CardsNA = ({ index, style }) => {
        const ev = eventosNA_ord[index]
        return (
            <div key={index} style={{ ...style, paddingBottom: '1px' }}>
                <CardEvento type={1} ev={ev} onClick={(e, evento) => countClick(e, evento, index)} id_ev_selecionado={eventoSelecionado.id == ev.id} />
            </div>
        )
    }

    const CardsEA = ({ index, style }) => {
        const ev = eventosEA_ord[index]
        return (
            <div key={index} style={{ ...style, paddingBottom: '1px' }}>
                <CardEvento type={2} ev={ev} onClick={(e, evento) => countClick(e, evento, index)} id_ev_selecionado={eventoSelecionado.id == ev.id} />
            </div>
        )
    }

    const CardsEE = ({ index, style }) => {
        const ev = eventosEE_ord[index]
        return (
            <div key={index} style={{ ...style, paddingBottom: '1px' }}>
                <CardEvento type={1} ev={ev} onClick={(e, evento) => countClick(e, evento, index)} id_ev_selecionado={eventoSelecionado.id == ev.id} />
            </div>
        )
    }

    const CardsEO = ({ index, style }) => {
        const ev = eventosEO_ord[index]
        return (
            <div key={index} style={{ ...style, paddingBottom: '1px' }}>
                <CardEvento type={1} ev={ev} onClick={(e, evento) => countClick(e, evento, index)} id_ev_selecionado={eventoSelecionado.id == ev.id} />
            </div>
        )
    }

    const handleStopCams = () => {
        return (eventoSelecionado.id == '')
    }

    const agruparEvento = (msg) => {
        if (msg.data.status) {
            const { id, agrupados, status_ev } = msg.data.evento
            let el = document.getElementById('agrup_ev_' + id)
            if (el) {
                el.innerHTML = `( ${agrupados} ) `
            }

            const func = definirFuncaoEvento(status_ev)

            func(current => {
                for (const i in current) {
                    if (current[i].id == id) {
                        current[i].agrupados = agrupados
                        break
                    }
                }
                return current
            })
        }
    }

    const definirFuncaoEvento = (statusEvento) => {
        switch (statusEvento) {
            case 1:
                return setEventosNA
            case 2:
                return setEventosEA
            case 3:
                return setEventosEE
            case 4:
                return setEventosEO
        }
    }

    const RetornoBuscarListagens = (msg) => {
        if (msg.cmd == 'buscarListagens') {
            if (msg.data.status && msg.data.listagens && msg.data.listagens.monitoresDigifort) {
                global.monitorDigifort = MeuMonitorDigifort(msg.data.listagens.monitoresDigifort)
            }
        }
    }

    /** Função que assume evento com o comando 'assumir_evento' do backend. Usado atualmente pra assumir OINIS automaticamente */
    function assumir_evento(evento) {
        const obsInputValue = document.getElementById('input-obs').value
        sendWs('gravarObservacao', { id: eventoSelecionado.id, observacao: obsInputValue })
        handleTrataEvento(2, evento.data, 0)
    }

    ordenaListasEventos()

    return (
        <Grid container xs={12} sx={{ ...Container, display: pathname == '/' ? '' : 'none' }} >
            {modalConfirmacaoEventoOpen &&
                <ModalConfirmacaoEvento
                    open={modalConfirmacaoEventoOpen}
                    setOpen={setModalConfirmacaoEventoOpen}
                    descricaoEvento={`${eventoDoubleClick.evento} - ${eventoDoubleClick.descricao}`}
                    nomeOperadorAtual={eventoDoubleClick.usuario_tratando?.nome}
                    mudarStatusEvento={() => {
                        mudarStatusEvento(eventoDoubleClick.id, 2)
                        addActiveCond(eventoDoubleClick.id_central)
                        setInfosEvento(eventoDoubleClick.id)
                    }}
                />
            }

            {modalConfirmaApagaVisitanteContext &&
                <ModalConfirmaApagaVisitanteContext
                    open={modalConfirmaApagaVisitanteContext}
                    setOpen={setModalConfirmaApagaVisitanteContext}
                    funcaoHandleClickEvento={funcaoHandleClickEvento}
                />
            }

            {/* Sessao Cameras e Monitoramento */}
            <Grid sx={SessaoMonitoramento} xl={4} lg={5} md={5} sm={5} xs={12}>
                {/* <Grid sx={TitleSession}><Videocam sx={IconTitleSession} />  Câmeras </Grid> */}

                {/* Cameras */}
                <Grid container sx={GridCamerasSx} xs={12}>
                    < GridCameras />
                </Grid>

                {/* Monitoramento */}
                <Grid container xs={12} sx={GridMonitoramento}>

                    {/* Não atendidos */}
                    <Grid xl={4} lg={4} md={6} sm={6} xs={6} sx={GridNaoAtendidos}>
                        <Box component={'div'} sx={TitleBoxMonitoramento}>
                            <NotificationsActive sx={IconTitleBoxMonitoramento} />
                            Não Atendidos ( {eventosNA.length} )
                        </Box>
                        <Box component={'div'} sx={BoxNaoAtendidos}>

                            {/* Criação dos cards de eventos 'Não Atendidos' */}
                            <EventosNA />

                        </Box>
                    </Grid>

                    {/* Em Atendimento */}
                    <Grid xl={4} lg={4} md={6} sm={6} xs={6} sx={GridEmAtendimento}>
                        <Box component={'div'} sx={TitleBoxMonitoramento}> <HeadsetMic sx={IconTitleBoxMonitoramento} />Em Atendimento ( {eventosEA.length} )</Box>
                        <Box component={'div'} sx={BoxEmAtendimento}>
                            {/* Criação dos cards de eventos 'Em atendimento' */}
                            <EventosEA />
                        </Box>
                    </Grid>

                    {/* Aguardando */}
                    <Grid container xl={4} lg={4} md={12} sm={12} xs={12} sx={{ height: '100%' }}>
                        <Grid xl={12} lg={12} md={6} sm={6} xs={6} sx={GridAguardando}>
                            <Box component={'div'} sx={TitleBoxMonitoramento}> <AccessTime sx={IconTitleBoxMonitoramento} /> Em Espera ( {eventosEE.length} )</Box>
                            <Box component={'div'} sx={BoxEmEspera}>
                                <EventosEE />
                            </Box>
                        </Grid>

                        <Grid xl={12} lg={12} md={6} sm={6} xs={6} sx={GridAguardando}>
                            <Box component={'div'} sx={TitleBoxMonitoramento}> <Search sx={IconTitleBoxMonitoramento} /> Em Observação ( {eventosEO.length} )</Box>
                            <Box component={'div'} sx={BoxEmEspera}>
                                <EventosEO />
                            </Box>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

            {/* Sessao Aba Web e Info de eventos */}
            <Grid sx={RightSessionSx} xl={7.6} lg={6.5} md={6.2} sm={6.5} xs={6.5} >
                <RightSession/>
            </Grid>

            {/* Sessao Escolher cond */}
            <Grid sx={SessaoCond} xl={0.4} lg={0.5} md={0.8} sm={5} xs={12} >
                <Grid sx={GridNumeroCond} xl={12} id='GridNumeroCond'>

                    <LupaPesquisarCond/>

                    <Box component='div'>
                        {condominios.length > 0 && condominios.map((cond, i) => {
                            const tooltip_titlee = (cond.apelido != "" ? cond.apelido : cond.nome)
                            return (
                                <div key={i} >
                                    <Tooltip title={tooltip_titlee} placement="left" arrow>
                                        <Box component='div'>
                                            <NumeroCond id_central={cond.id_central} handleChangeCond={handleChangeCond} />
                                        </Box>
                                    </Tooltip>
                                </div>
                            )
                        })}
                    </Box>
                </Grid>
                <Grid sx={GridNumeroVersao} xl={12} id="versao_sistema"></Grid> {/* Preenchido em tempo de execucao */}
            </Grid>
        </Grid>
    )
}

export default MonitoramentoPage
